const trimUrlLastPart = (url: string | undefined): string => (url ? url.replace(new RegExp('/[^/]+?/?$'), '') : '');

export { trimUrlLastPart };
